import api from '../config/axiosConfig';
import { API_BASE_URL } from '../utils/constants';
import { AuthResponse } from '../types/auth';

const authService = {
  login: async (username: string, password: string): Promise<AuthResponse> => {
    // Backend menggunakan OAuth2PasswordRequestForm (form-data)
    const formData = new FormData();
    formData.append('username', username);
    formData.append('password', password);
    
    const response = await api.post(`${API_BASE_URL}/auth/login`, formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    return response.data;
  },

  logout: async (): Promise<void> => {
    // Backend tidak memiliki endpoint logout
    // Cukup hapus token dari localStorage
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },

  getCurrentUser: async (): Promise<AuthResponse> => {
    // Backend endpoint adalah /auth/me bukan /auth/current-user
    const response = await api.get(`${API_BASE_URL}/auth/me`);
    return response.data;
  },

  changePassword: async (currentPassword: string, newPassword: string): Promise<void> => {
    await api.post(`${API_BASE_URL}/auth/change-password`, {
      current_password: currentPassword,
      new_password: newPassword,
    });
  },
};

export default authService;
